<template>
  <MUIDialog
    class="mui-dialog--confirm"
    :acceptItem="acceptAndCloseItem"
    :dismissItem="dismissItem"
    :displayType="displayType"
    :title="title"
    ref="dialog">
    <section>
      <p>{{message}}</p>
    </section>
  </MUIDialog>
</template>

<script>
import {
  MUIDialog
} from '../components'

import { CONTEXT } from '../config'

export default {
  components: {
    MUIDialog
  },
  props: [
    'acceptItem',
    'dismissItem',
    'message',
    'title'
  ],
  data () {
    return {
      displayType: CONTEXT
    }
  },
  computed: {
    acceptAndCloseItem () {
      return {
        icon: this.acceptItem.icon,
        name: this.acceptItem.name,
        fn: () => {
          if (this.acceptItem.fn()) this.$refs.dialog.close()
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/ConfirmDialog.vue